<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
      <CCard>
        <CCardHeader>
          <h4>Προγραμματισμένες Υποθέσεις</h4>
        </CCardHeader>
        <CCardBody>
          <CModal
            class="modalAlert"
            :show.sync="alertIsShown"
            :centered="true"
            size="lg"
          >
            <CAlert
              closeButton
              :show.sync="alertIsShown"
              color="primary"
              fade
            >
              {{ message }}
            </CAlert>
          </CModal>
          <CButton
            color="primary"
            class="mb-2"
            @click="xlsCode"
            target="_blank"
          >
            Download (.xls)
          </CButton>
          <CDataTable
            :items="dateFilteredItems"
            :fields="fields"
            :items-per-page="10"
            pagination
            column-filter
            table-filter
            hover
            striped
            :loading="loading"
            sorter
            @row-clicked="(item) => showCase(item.id)"
            clickable-rows
          >
          <template #next_visit-filter="">
            <span>Από:</span>
            <input
              type="date"
              :value="new Date(startDate).toISOString().substr(0, 10)"
              @change="setDateFilter"
              class="paddingBottomFormControl"
            /><br>
            <span>Έως:</span>
            <input
              type="date"
              :value="new Date(endDate).toISOString().substr(0, 10)"
              @change="e => setDateFilter(e, 'end')"
            />        
          </template>
          <template #service-filter>
            <div class="selectFilter">
              <CSelect
                :options="servicesOptions"
                :value.sync="selectedIsoOption"
              />
            </div>
          </template>
          <template #country-filter>
            <div class="selectFilter">
              <CSelect
                :options="countriesOptions"
                :value.sync="selectedCountry"
              />
            </div>
          </template>
          <template #next_visit="{item}">
            <td>
              {{ item.next_visit }}
            </td>
          </template>
          <template #status="{item}">
            <td>
              <CBadge :color="item.status.class">{{ item.status.name }}</CBadge>
            </td>
          </template>
          <template #client="{item}">
            <td>
              {{ item.client }}
            </td>
          </template>
          <template #service="{item}">
            <td>
              {{ item.service }}
            </td>
          </template>
          <template #service_subcategories="{item}">
            <td>
              {{ item.service_subcategories }}
            </td>
          </template>
          <template #country="{item}">
            <td>
              {{ item.country }}
            </td>
          </template>
          <template #actions="{item}">
            <td class="button-cell">
              <CButton
                color="primary"
                class="btn-icon"
                @click.stop="editCase( item.id )"
                v-c-tooltip="'Επεξεργασία'"
              >
                <CIcon name="cilPencil" />
              </CButton>
            </td>
          </template>
        </CDataTable>
        </CCardBody>
      </CCard>
      </transition>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import js2excel from 'js2excel';

const fields = [
  'case_code',
  {
    key: 'next_visit', 
    label: 'Επόμενη Επίσκεψη', 
    sorter: true, 
    filter: true
  },
  {
    key: 'status', 
    label: 'Κατάσταση', 
    sorter: false, 
    filter: false
  },
  {
    key: 'client', 
    label: 'Πελάτης', 
    sorter: true, 
    filter: true
  },
  {
    key: 'service', 
    label: 'Πρότυπο', 
    sorter: true, 
    filter: true
  },
  {
    key: 'service_subcategories', 
    label: 'Υποκατηγορία', 
    sorter: true, 
    filter: true
  },
  {
    key: 'country',
    label: 'Χώρα',
    sorter: true,
    filter: true
  },
  {
    key: 'actions',
    label: '',
    sorter: false,
    filter: false
  }
]

export default {
  name: 'ReportsScheduled',
  data: () => {
    return {
      items: [],
      fields,
      startDate: moment(new Date()).format('YYYY-MM-DD'),
      endDate: moment(new Date()).add(2, 'M').format('YYYY-MM-DD'),
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      disabledFilter: true,
      selectedIsoOption: 'Καμία επιλογή',
      servicesOptions: ['Καμία επιλογή'],
      selectedCountry: 'Καμία επιλογή',
      countriesOptions: ['Καμία επιλογή'],
      you: null,
      message: '',
      showMessage: false,
      dismissSecs: 7,
      dismissCountDown: 0,
      alertIsShown: false,
      loading: true,
      showDismissibleAlert: false
    }
  },
  paginationProps: {
    align: 'center',
    doubleArrows: false,
    previousButtonHtml: 'prev',
    nextButtonHtml: 'next'
  },
  computed: {
    dateFilteredItems() {
      return this.items.filter(item => {
        const date = item.next_visit;

        if (this.selectedIsoOption == "Καμία επιλογή") {
          if(this.selectedCountry == "Καμία επιλογή" ){
            return date >= this.startDate && date <= this.endDate
          }
          else{
            return date >= this.startDate && date <= this.endDate && item.country == this.selectedCountry
          } 
        } else {
          if(this.selectedCountry == "Καμία επιλογή" ){
            return date >= this.startDate && date <= this.endDate && item.service == this.selectedIsoOption
          }else{
            return date >= this.startDate && date <= this.endDate && item.service == this.selectedIsoOption && item.country == this.selectedCountry
          }
          
        }
      })
    }
  },
  watch: {
    alertIsShown: function(newVal, oldVal) {
      if (! newVal && this.saved) {
        this.$emit('closed-alert');
      }
    }
  },
  methods: {
    xlsCode () {
      this.tempArr = this.dateFilteredItems.map((item) => {
        return {
          'Case Code': item.case_code,
          'Επόμενη Επίσκεψη': item.next_visit,
          Κατάσταση: item.status.name,
          Πελάτης: item.client,
          Πρότυπο: item.service,
          Υποκατηγορία: item.service_subcategories
        }
      });

      try {
        js2excel.json2excel({
            data: this.tempArr,
            name: 'scheduled-cases-data',
            formateDate: 'dd/mm/yyyy'
        });
      } catch (e) {
          console.error('export error: ', e);
      }
    },
    setDateFilter (e, end) {
      if (end) {
        this.endDate = moment(new Date(e.target.value)).format('YYYY-MM-DD')
      } else {
        this.startDate = moment(new Date(e.target.value)).format('YYYY-MM-DD')
      }
    },
    getSubcategory(subcategory) {
      let temp = [];
      let text = '';
      temp = subcategory.map((item) => {return item.name;});
      text = temp.join(", ");
      return text;
    },
    caseLink (id) {
      return `cases/${id.toString()}`
    },
    editLink (id) {
      return `cases/${id.toString()}/edit`
    },
    showCase ( id ) {
      const caseLink = this.caseLink( id );
      this.$router.push({path: caseLink});
    },
    editCase ( id ) {
      const editLink = this.editLink( id );
      this.$router.push({path: editLink});
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.alertIsShown = true
    },
    getCases (){
      let self = this;
      const countries = new Set();

      axios.get('/api/cases/filteredIndex' + '?status=3' + '&token=' + localStorage.getItem("api_token"))
      .then(function (response) {
        self.loading = false;
        console.log(response.data)
        self.items = response.data.cases.map((item) => {
          item.country = item.client.countries.name;
          countries.add(item.client.countries.name)
          item.client = item.client.company;
          item.service = item.service.name;
          item.next_visit = item.next_visit[0];
          item.service_subcategories = self.getSubcategory(item.service_subcategories);
          return item;
        });

        
        self.countriesOptions = ['Καμία επιλογή', ...countries];
        self.selectedCountry = self.servicesOptions[0];
        }).catch(function (error) {
          self.loading = false;
          console.log(error);
          self.$router.push({ path: '/login' });
        });
    },
  },
  mounted: function(){
    this.getCases();

    let self = this;
    axios.get('/api/services?token=' + localStorage.getItem("api_token"))
    .then(function (response) {
      self.services = response.data.services.map((item) => {
        return item;
      });

      self.servicesOptions = ['Καμία επιλογή', ...new Set(self.services.map(item => item.name))];
      self.selectedIsoOption = self.servicesOptions[0];

    }).catch(function (error) {
      console.log(error);
      self.loading = false;
      self.$router.push({ path: '/login' });
    });
  }
}
</script>